//
// GENERATED by KVision
//
package pl.finn.forms.sekap1794

import io.kvision.remote.HttpMethod
import io.kvision.remote.KVServiceManager
import io.kvision.remote.registerKVisionServiceExceptions

expect class Sekap1794Service : ISekap1794Service

object Sekap1794ServiceManager : KVServiceManager<Sekap1794Service>(Sekap1794Service::class) {
    init {
        registerKVisionServiceExceptions()
        bind(ISekap1794Service::nowy, HttpMethod.POST, null)
        bind(ISekap1794Service::edycja, HttpMethod.POST, null)
        bind(ISekap1794Service::zapisz, HttpMethod.POST, null)
        bind(ISekap1794Service::podglad, HttpMethod.POST, null)
    }
}
